import { yupResolver } from "@hookform/resolvers/yup";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "utils/PageTitle";
import * as yup from "yup";
import StoresTable from "./StoresTable";
import BanksTable from "./BanksTable";
import WarehousesTable from "./WarehousesTable";
import { CONSTANT_ROUTES } from "routes";

const schema = yup
  .object({
    customer: yup.string(),
    product: yup.string(),
    variant: yup.string(), // optional
    quantity: yup.number(),
    // .typeError("Quantity must be a number")
    // .integer("Quantity must be an integer")
    // .min(1, "Quantity must be at least 1")
    // .required("Quantity is required"),
    addedAt: yup.date(),
    // .typeError("Added At must be a valid date")
    // .required("Added At is required"),
  })
  .required();

const AddSeller = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("stores");
  const [showProductsPage, setShowProductsPage] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    // console.log(myData);

    // try {
    //   if (location?.state) {
    //     setLoading(true);
    //     await WeighmentIndicatorsAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Weighment Indicator Updated Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   } else {
    //     setLoading(true);
    //     await WeighmentIndicatorsAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Weighment Indicator Created Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   }

    //   // ------- Get all object keys form data and set empty values to reset ------------
    //   const keys = Object.keys(data);
    //   for (const key of keys) {
    //     submittedValues[key] = "";
    //   }
    //   reset({ ...submittedValues });
    //   navigate(-1);
    // } catch (error) {
    //   toast.error("Something Went Wrong", {
    //     position: customSettings.toastPosition,
    //     autoClose: customSettings.toastClose,
    //   });
    //   console.log(error);
    // }
  };

  useEffect(() => {
    if (location?.state) {
      console.log(location?.state);
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="Shopenze | Sellers" />
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <BreadCrumbTable
                    title="Shopenze"
                    subTitle={
                      <span
                        className="cursor-pointer"
                        onClick={() => navigate(CONSTANT_ROUTES.SELLERS)}
                      >
                        Sellers
                      </span>
                    }
                    subSubTitle={
                      <span
                        className="cursor-pointer"
                        onClick={() => navigate(CONSTANT_ROUTES.SELLERS)}
                      >
                        {location?.state?.firstName +
                          " " +
                          location?.state?.lastName}
                      </span>
                    }
                  />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="button"
                    onClick={() => navigate(-1)}
                    // disabled={loading}
                  >
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Col lg={12}>
              <Card className="mb-3 py-2">
                <div className="d-flex justify-content-between align-items-center border-bottom">
                  <Tabs
                    id="vendor-wizard"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="flex-grow-1 border-0 "
                  >
                    <Tab eventKey="stores" title="Stores" />
                    <Tab eventKey="banks" title="Bank Accounts" />
                    <Tab eventKey="warehouse" title="Warehouses" />
                  </Tabs>
                </div>

                <div className="">
                  {key === "stores" && <StoresTable />}
                  {key === "banks" && <BanksTable />}
                  {key === "warehouse" && <WarehousesTable />}
                </div>
              </Card>
            </Col>
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddSeller;
